export enum ReportStatus {
  Pending = 0,
  TBD = 1,
  Reviewed = 2,
  Rejected = 3,
}

export const ReportStatusList = [
  ReportStatus.Pending,
  ReportStatus.TBD,
  ReportStatus.Reviewed,
  ReportStatus.Rejected,
];
